import React from 'react';
import { motion } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
const comparisons = [{
  without: 'Improvisar en cada encuentro difícil',
  with: 'Protocolo claro para cada momento del proceso'
}, {
  without: 'No saber qué hacer cuando recae',
  with: 'Plan de 48 horas listo para activar'
}, {
  without: 'Siempre las mismas preguntas que no abren nada',
  with: '80 preguntas organizadas por momento y función'
}, {
  without: 'Horas buscando material en español que nunca encontrás',
  with: '240 páginas de herramientas listas para usar'
}, {
  without: 'Desgastarte sin saber si lo que hacés funciona',
  with: 'Indicadores de avance claros para leer el proceso'
}, {
  without: 'Armar fichas desde cero antes de cada encuentro',
  with: 'Kit de fichas imprimibles listas para usar'
}, {
  without: 'Cargar los casos sin saber qué hacer con lo que te pesa',
  with: 'Herramientas de autocuidado reales y aplicables'
}, {
  without: 'Trabajar sin estructura visible de avance',
  with: 'Sistema completo del primer contacto al cierre'
}];
export function Comparison() {
  return <section className="py-10 md:py-20 px-4" data-id="element-100">
      <div className="max-w-5xl mx-auto" data-id="element-101">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-serif text-2xl md:text-4xl font-bold text-navy-dark text-center mb-8 md:mb-12" data-id="element-102">
          ¿Cuánto cuesta NO tenerlo?
        </motion.h2>

        <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100" data-id="element-103">
          <div className="grid grid-cols-2" data-id="element-104">
            <div className="bg-red-50 border-b-2 border-red-200 p-2.5 md:p-4 text-center" data-id="element-105">
              <h3 className="font-bold text-navy-dark text-xs md:text-base" data-id="element-106">
                Sin el sistema
              </h3>
            </div>
            <div className="bg-green-50 border-b-2 border-gold p-2.5 md:p-4 text-center" data-id="element-107">
              <h3 className="font-bold text-navy-dark text-xs md:text-base" data-id="element-108">
                Con el sistema
              </h3>
            </div>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-109">
            {comparisons.map((comparison, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="grid grid-cols-2" data-id="element-110">
                <div className="bg-red-50/30 p-2.5 md:p-4 flex items-start gap-1.5 md:gap-2.5 border-r border-gray-100" data-id="element-111">
                  <X className="w-3.5 h-3.5 md:w-5 md:h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-112" />
                  <span className="text-gray-700 text-[11px] md:text-sm leading-snug" data-id="element-113">
                    {comparison.without}
                  </span>
                </div>
                <div className="bg-green-50/30 p-2.5 md:p-4 flex items-start gap-1.5 md:gap-2.5" data-id="element-114">
                  <CheckCircle2 className="w-3.5 h-3.5 md:w-5 md:h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-115" />
                  <span className="text-gray-700 text-[11px] md:text-sm leading-snug" data-id="element-116">
                    {comparison.with}
                  </span>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}